import { Wallet, ArrowRight, Menu, X } from 'lucide-react';
import Link from 'next/link';
import { useState } from 'react';
import { usePathname } from 'next/navigation';

export default function Header() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const pathname = usePathname();

    const isActivePage = (path) => {
        return pathname === path;
    };

    return (
        <header className="top-0 sticky w-full z-50 bg-white backdrop-blur-md border-b border-slate-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-20">
                    <Link href="/">
                        <div className="flex items-center space-x-3">
                            <div className="w-10 h-10 rounded-xl flex items-center justify-center">
                               <img src="/businesswallet.svg" alt="BusinessWallet" className='scale-150' />
                            </div>
                            <span className="text-xl font-bold bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
                                BusinessWallet.eu
                            </span>
                        </div>
                    </Link>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex items-center space-x-8">
                        <Link 
                            href="/blog" 
                            className={`text-slate-600 hover:text-slate-900 transition-colors font-medium pb-1 ${
                                isActivePage('/blog') ? 'border-b-2 border-sky-500' : ''
                            }`}
                        >
                            Blogs
                        </Link>
                        <Link 
                            href="/features" 
                            className={`text-slate-600 hover:text-slate-900 transition-colors font-medium pb-1 ${
                                isActivePage('/features') ? 'border-b-2 border-sky-500' : ''
                            }`}
                        >
                            Features
                        </Link>
                        <Link 
                            href="/about" 
                            className={`text-slate-600 hover:text-slate-900 transition-colors font-medium pb-1 ${
                                isActivePage('/about') ? 'border-b-2 border-sky-500' : ''
                            }`}
                        >
                            About Us
                        </Link>
                    </nav>

                    {/* Desktop CTA Button */}
                    <div className="hidden md:flex items-center space-x-4">
                        <a
                            href="#early-access"
                            className="bg-gradient-to-r from-sky-500 to-indigo-500 text-white px-6 py-2.5 rounded-xl font-medium hover:opacity-90 transition-opacity flex items-center space-x-2 shadow-sm"
                        >
                            <span>Get Early Access</span>
                            <ArrowRight className="w-4 h-4" />
                        </a>
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        onClick={() => setIsMobileMenuOpen(true)}
                        className="md:hidden p-2 text-slate-600 hover:text-slate-900"
                    >
                        <Menu className="w-6 h-6" />
                    </button>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            {isMobileMenuOpen && (
                <div className="fixed inset-0 z-[9999] h-screen w-screen bg-white flex flex-col">
                    <div className="flex justify-between items-center p-4 border-b border-slate-200">
                        <Link href="/" onClick={() => setIsMobileMenuOpen(false)}>
                            <div className="flex items-center space-x-3">
                                <div className="w-10 h-10 rounded-xl flex items-center justify-center">
                                    <Wallet className="w-6 h-6 text-sky-500" />
                                </div>
                                <span className="text-xl font-bold bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
                                    BusinessWallet.eu
                                </span>
                            </div>
                        </Link>
                        <button
                            onClick={() => setIsMobileMenuOpen(false)}
                            className="p-2 text-slate-600 hover:text-slate-900"
                        >
                            <X className="w-6 h-6" />
                        </button>
                    </div>
                    <div className="flex-1 flex flex-col justify-between overflow-y-auto">
                        <nav className="flex flex-col items-start px-6 py-8 space-y-6">
                            <Link 
                                href="/blog" 
                                className="block text-2xl font-medium text-slate-900 hover:text-sky-500"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                Blog
                            </Link>
                            <Link 
                                href="/features" 
                                className="block text-2xl font-medium text-slate-900 hover:text-sky-500"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                Features
                            </Link>
                            <Link 
                                href="/about" 
                                className="block text-2xl font-medium text-slate-900 hover:text-sky-500"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                About Us
                            </Link>
                        </nav>
                        <div className="p-6 border-t border-slate-200 bg-white">
                            <div className="space-y-4">
                                <h3 className="text-lg font-medium text-slate-900">Get Early Access</h3>
                                <div className="flex space-x-2">
                                    <input
                                        type="email"
                                        placeholder="Enter your email"
                                        className="flex-1 px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500"
                                    />
                                    <button className="bg-gradient-to-r from-sky-500 to-indigo-500 text-white px-4 py-2 rounded-xl font-medium hover:opacity-90 transition-opacity flex items-center space-x-2">
                                        <span>Join</span>
                                        <ArrowRight className="w-4 h-4" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </header>
    );
} 